
export default function SummaryItemDetailsRow({ label, value, type = 'currency',tooltip, children }) {

    const rowMap = {
        currency: <><span className="shekel-mrk">₪</span>{value?.toLocaleString('he-IL', { maximumFractionDigits: 2 })}{children}</>,
        percent: <>{value?.toLocaleString('he-IL', { maximumFractionDigits: 1 })}<span className="shekel-mrk">%</span>{children}</>,
        strikeCurrency: <><s className='strike'><span className="shekel-mrk">₪</span>{value?.toLocaleString('he-IL', { maximumFractionDigits: 2 })}</s><span className="shekel-mrk">₪</span>{children?.toLocaleString('he-IL')}</>,
        strike: <><s className='strike'>{value}</s>{children}</>,
        text: <>{value}&nbsp;{children}</>
    }


    return (
        <div className="summary-item-details-row">
            <span className="label">{label}{(tooltip) && <div role="tooltip" aria-label={tooltip} tool-tip={tooltip}><img src="./icons/question-mark-circle.svg" alt='?' /></div>}</span>
            <span className="value">
                {rowMap[type]}
            </span>
        </div>
    )
}
